/* global dataLayer */

import { graphql } from 'gatsby';
import React, { Component } from 'react';
import '@ookla/common-ui/lib/styles';
import Header from './../components/header/header';
import CountryPanel from './../components/country-panel/country-panel';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { edgesToSearchData, getAwardTypeRoute } from './../utils/format';
import c from './../utils/constants';
import styles from './../styles/pages/index.css';
import classNames from 'classnames';
import phoneIcon from './../images/icons/ic-phone.svg';
import routerIcon from './../images/icons/ic-router.svg';
import coverageIcon from './../images/icons/ic-coverage.svg';
import carrierTopRatedIcon from './../images/icons/ic-top-rated-cell.svg';
import providerTopRatedIcon from './../images/icons/ic-top-rated-fixed.svg';

import fastest5GIcon from './../images/icons/icg-5g.svg';
import bestMobileNetworkIcon from './../images/icons/icg-best-mobile-network.svg';
import bestFixedNetworkIcon from './../images/icons/icg-best-fixed-network.svg';
import videoExperienceIcon from './../images/icons/icg-best-vid-exp-5g-mobile.svg';
import bestVideoFixedIcon from './../images/icons/icg-best-vid-exp-fixed.svg';
import bestVideoMobileIcon from './../images/icons/icg-best-vid-exp-mobile.svg';

import best5gGamingExperienceIcon from './../images/icons/icg-best-5g-gaming-experience.svg';
import bestMobileGamingExperienceIcon from './../images/icons/icg-best-mobile-gaming-experience.svg';
import bestIspGamingExperienceIcon from './../images/icons/icg-best-isp-gaming-experience.svg';

import best5GIcon from './../images/icons/icg-best-5g.svg';


import { Helmet } from 'react-helmet';
import { countries } from '../data/json/countries.json';
import Layout from '../components/layout';

export default class IndexPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ''
    };
  }
  static propTypes = {
    data: PropTypes.shape({
      edges: PropTypes.array,
      search: PropTypes.object
    }),
    location: PropTypes.object
  };
  handleSearchChange = (search) => {
    this.setState({
      search
    });
  };
  getHeaderData = () => {
    return {
      title: 'Speedtest Awards presented by Ookla',
      desc: 'Speedtest Awards represent real world network performance and the internet speeds operators provide to their customers.'
    };
  };
  componentDidMount() {
    const {
      location: { pathname }
    } = this.props;

    const pageTitle = this.getHeaderData().title;

    // send event to GTM
    typeof dataLayer !== 'undefined' &&
      dataLayer.push({
        pageTitle,
        virtualUrl: pathname,
        event: 'virtualPageview'
      });
  }
  render() {
    const {
      data: {
        search: { edges }
      }
    } = this.props;
    const { search } = this.state;
    const headerData = this.getHeaderData();
    return (
      <Layout>
        <div>
          <Helmet>
            <html lang="en" />
            <meta name="description" content={headerData.desc} />
            <title>{headerData.title}</title>
          </Helmet>
          <div className="section section-dark section-blue section-md">
            <div className="container">
              <Header
                parent="home"
                onSearchChange={this.handleSearchChange}
                displaySearchSuggestions={true}
                searchData={edgesToSearchData(edges)}
                search={search}
              />
              <div className="pure-g">
                <div className="pure-u-1 pure-u-md-7-12 u-c">
                  <div className={styles.hero}>
                    <h1 className={styles.header}>Speedtest Awards</h1>
                    <p className={styles.homePageCopy}>
                      Speedtest Awards<sup>™</sup>, presented by Ookla<sup>®</sup>, are an elite designation reserved for fixed and mobile
                      providers in a market. Based on consumer-initiated tests and background scans from Speedtest<sup>®</sup>
                      applications, Speedtest Awards represent real world network performance and the internet speeds
                      and coverage provided to customers.
                    </p>
                    <p className={classNames(styles.homePageCopy, styles.olderAwardsCopy)}>
                      To learn more about how Speedtest Awards are determined, visit our{' '}
                      <a href={c.methodologyLink}>methodology page</a>.
                    </p>
                  </div>
                </div>
              </div>
              <div className="pure-g">
                <div className="pure-u-1 u-c">
                  <CountryPanel continents={countries} />
                </div>
              </div>

              <div className="container">
                <div className={`pure-g ${styles.links}`}>

                  {c.awardTypes.carrier.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={styles.linkBox}>
                        <Link to={getAwardTypeRoute('carrier')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: phoneIcon }} />
                          <span>Fastest Mobile Network</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes.isp.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={styles.linkBox}>
                        <Link to={getAwardTypeRoute('isp')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: routerIcon }} />
                          <span>Fastest Fixed Network</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes.coverage.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={styles.linkBox}>
                        <Link to={c.coverageLink}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: coverageIcon }} />
                          <span>Best Mobile Coverage</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes.best_mobile.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('best_mobile')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: bestMobileNetworkIcon }} />
                          <span>Best Mobile Network</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes.best_fixed.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('best_fixed')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: bestFixedNetworkIcon }} />
                          <span>Best Fixed Network</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.showTopRatedContent && c.awardTypes.top_rated_provider.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('top_rated_provider')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: providerTopRatedIcon }} />
                          <span>Top-Rated Fixed Network</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes['5g'].visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('5g')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: fastest5GIcon }} />
                          <span>Fastest 5G Mobile Network</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes.best_5g_gaming_experience.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('best_5g_gaming_experience')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: best5gGamingExperienceIcon }} />
                          <span>Best 5G Gaming Experience</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes.best_mobile_gaming_experience.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('best_mobile_gaming_experience')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: bestMobileGamingExperienceIcon }} />
                          <span>Best Mobile Gaming Experience</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes.best_isp_gaming_experience.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('best_isp_gaming_experience')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: bestIspGamingExperienceIcon }} />
                          <span>Best ISP Gaming Experience</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.showTopRatedContent && c.awardTypes.top_rated_carrier.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('top_rated_carrier')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: carrierTopRatedIcon }} />
                          <span>Top-Rated Mobile Network</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.showTopRatedContent && c.awardTypes['5g_video_experience'].visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('5g_video_experience')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: videoExperienceIcon }} />
                          <span>Best 5G Video Experience</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.showTopRatedContent && c.awardTypes.best_mobile_video_experience.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('best_mobile_video_experience')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: bestVideoMobileIcon }} />
                          <span>Best Mobile Video Experience</span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.showTopRatedContent && c.awardTypes.best_isp_video_experience.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('best_isp_video_experience')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: bestVideoFixedIcon }} />
                          <span>Best ISP Video Experience </span>
                        </Link>
                      </div>
                    </div>
                  )}

                  {c.awardTypes.best_5g.visible && (
                    <div className="pure-u-1 pure-u-md-1-3 u-c">
                      <div className={`${styles.secondRow} ${styles.linkBox}`}>
                        <Link to={getAwardTypeRoute('best_5g')}>
                          <svg className={styles.icon} dangerouslySetInnerHTML={{ __html: best5GIcon }} />
                          <span>Best 5G Network</span>
                        </Link>
                      </div>
                    </div>
                  )}

                </div>
              </div>

              <div className="container">
                <div className="pure-g">
                  <div className={`pure-u-1 pure-u-md-1 u-c ${styles.legacyCTA}`}>
                    <p>
                      <a href={c.legacySiteURL}>View Speedtest Awards from Previous Years</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section section-dark section-black-blue section-lg" />
        </div>
      </Layout>
    );
  }
}
export const query = graphql`
  query IndexPage {
    search: allSitePage {
      ...Search
    }
  }
`;
